var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilities2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_12_1",
    "data-name": "Component 12 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.491,
    height: 83.231,
    viewBox: "0 0 143.491 83.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 143.491,
    height: 83.231,
    fill: "none",
    stroke: "#e0e1e5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94-2",
    "data-name": "Rectangle 94",
    width: 143.491,
    height: 83.231,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M90.932,39.124a25.029,25.029,0,1,1-25.026-25.03A25.032,25.032,0,0,1,90.932,39.124Z",
    transform: "translate(51.096 17.618)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M49.45,46.979A25.032,25.032,0,1,1,25.68,14.094c11.844,0,21.767,8.706,24.364,19.776",
    transform: "translate(0.813 17.618)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M37.359.5H42.89a4.485,4.485,0,0,1,4.277,2.79c.23.574,1.778,9.216,3.816,15.292,4.59,13.71,18.926,37.7,18.926,37.7",
    transform: "translate(46.702 0.624)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y1: 28.059,
    x2: 29.751,
    transform: "translate(70.585 25.974)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M66.424,8.661H25.007l8.366,31.618",
    transform: "translate(31.261 10.826)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M40.305,5.074v8.071L12.769,47.673",
    transform: "translate(15.962 6.342)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M51.552,22.713c-.533,0-38.141,3.092-38.141,3.092a2.945,2.945,0,0,0-2.945,2.945,2.908,2.908,0,0,0,2.579,2.871l0,.045s37.709,6.147,38.51,6.147a7.55,7.55,0,1,0,0-15.1Z",
    transform: "translate(13.082 28.392)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M23.943.721s27.3,2.232,22.733,4.257c-7.142,3.166-13,5.537-13,5.537C27.456,10.984,8.6,1.126,23.943.721Z",
    transform: "translate(22.586 0.9)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43-2",
    "data-name": "Group 43",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229-2",
    "data-name": "Path 229",
    d: "M90.932,39.124a25.029,25.029,0,1,1-25.026-25.03A25.032,25.032,0,0,1,90.932,39.124Z",
    transform: "translate(51.096 17.618)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230-2",
    "data-name": "Path 230",
    d: "M49.45,46.979A25.032,25.032,0,1,1,25.68,14.094c11.844,0,21.767,8.706,24.364,19.776",
    transform: "translate(0.813 17.618)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231-2",
    "data-name": "Path 231",
    d: "M37.359.5H42.89a4.485,4.485,0,0,1,4.277,2.79c.23.574,1.778,9.216,3.816,15.292,4.59,13.71,18.926,37.7,18.926,37.7",
    transform: "translate(46.702 0.624)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56-2",
    "data-name": "Line 56",
    y1: 28.059,
    x2: 29.751,
    transform: "translate(70.585 25.974)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232-2",
    "data-name": "Path 232",
    d: "M66.424,8.661H25.007l8.366,31.618",
    transform: "translate(31.261 10.826)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233-2",
    "data-name": "Path 233",
    d: "M40.305,5.074v8.071L12.769,47.673",
    transform: "translate(15.962 6.342)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234-2",
    "data-name": "Path 234",
    d: "M51.552,22.713c-.533,0-38.141,3.092-38.141,3.092a2.945,2.945,0,0,0-2.945,2.945,2.908,2.908,0,0,0,2.579,2.871l0,.045s37.709,6.147,38.51,6.147a7.55,7.55,0,1,0,0-15.1Z",
    transform: "translate(13.082 28.392)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235-2",
    "data-name": "Path 235",
    d: "M23.943.721s27.3,2.232,22.733,4.257c-7.142,3.166-13,5.537-13,5.537C27.456,10.984,8.6,1.126,23.943.721Z",
    transform: "translate(22.586 0.9)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities2);
export default __webpack_public_path__ + "static/media/utilities2.0ce5d58b004960986610a18e48a2864c.svg";
export { ForwardRef as ReactComponent };